import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import ImageUpload, { ImageUploadValue } from 'src/Elements/ImageUpload/ImageUpload'
import carUnderCloth from 'src/Resources/Images/VehicleIntegration/carUnderCloth.svg'
import { VehicleSettingsFormFieldNames, VehicleSettingsFormValues } from '../../types'

export interface VehicleImageUploadProps {
  initialImageUrl?: string | null
  hasCustomImage?: boolean
}

export type VehicleImageUploadValue = File | string

const VehicleImageUpload: React.FC<VehicleImageUploadProps> = ({ initialImageUrl = null, hasCustomImage = false }) => {
  const { control } = useFormContext<VehicleSettingsFormValues>()

  return (
    <Controller
      control={control}
      name={VehicleSettingsFormFieldNames.CustomImage}
      render={({ field }) => (
        <ImageUpload
          placeholderImage={carUnderCloth}
          initialImageUrl={initialImageUrl}
          canDelete={hasCustomImage || field.value instanceof File}
          onChange={(value: ImageUploadValue | null) => {
            if (value === null) {
              field.onChange('')
            } else if (value.croppedImageFormData) {
              field.onChange(value.croppedImageFormData)
            }
          }}
        />
      )}
    />
  )
}

export default VehicleImageUpload
